import { ReactElement } from 'react';

import { ChipValueFormatter } from '@pp/core/src/formatters/ChipValueFormatter/ChipValueFormatter';

import { Bets } from '../../config';
import { useQuickBetDisabled } from '../gameGrid/hooks';

import { QuickBet } from './QuickBet';

export interface QuickBetConnectedProps {
    betCode: Bets;
    value: number;
    locale: string;
    onQuickBet: (value: number) => void;
    totalTip: string;
    pointerLeave: () => void;
}
export const QuickBetConnected = ({ betCode, value, locale, onQuickBet, totalTip, pointerLeave }: QuickBetConnectedProps): ReactElement => {
    const isNewQuickBetBehaviour = true;
    const isDisabled = useQuickBetDisabled(betCode, value, isNewQuickBetBehaviour);

    return (
        <QuickBet
            weight={value}
            value={ChipValueFormatter.format(locale, value)}
            isDisabled={isDisabled}
            onQuickBet={onQuickBet}
            totalTip={totalTip}
            pointerLeave={pointerLeave}
            betCode={betCode}
        />
    );
};
